import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {I18nUtils} from "../../../i18n/I18nUtils";

export default class Paginator extends React.Component {

  static buildPagerData(elements, page, numElements = 10){
    return {
      current: page,
      total_pages: Math.ceil( elements.length / numElements ),
      total_elements: elements.length
    };
  }

  static buildData(elements, page, numElements = 10){
    return elements.slice(numElements * (page - 1), numElements * page)
  }

  selectPage(page){
    if (page > 0 && page <= this.props.data.total_pages){
      this.props.onPage(page);
    }
  }

  renderPageNumbers(){
    let minValue = this.props.data.current - 2;
    if (minValue <= 0 ){
      minValue = 1;
    }

    let maxValue = this.props.data.current + 2;
    if (maxValue > this.props.data.total_pages ){
      maxValue = this.props.data.total_pages;
    }


    const pages = _.range(minValue, maxValue + 1);
    return pages.map((page, i) => {
      return (
        <li key={i} className={this.props.data.current === page ? 'active' : '' }>
          <a className="waves-effect" onClick={() => this.selectPage(page)}>{page}</a>
        </li>
      );
    });
  }

  renderPreviousPage(){
    return(
      <li className={this.props.data.current - 1 <= 0 ? 'disabled':'' }>
        <a className="waves-effect" onClick={() => this.selectPage(this.props.data.current - 1)}>
          <i className="material-icons">chevron_left</i>
        </a>
      </li>
    );
  }

  renderNextPage(){
    return(
      <li className={this.props.data.current + 1 > this.props.data.total_pages ? 'disabled':'' }>
        <a className="waves-effect" onClick={() => this.selectPage(this.props.data.current + 1)}>
          <i className="material-icons">chevron_right</i>
        </a>
      </li>
    );
  }

  render() {
    if (!this.props.data || this.props.data.total_pages === 0){
      return null;
    }

    return (
      <nav className="row footer-pagination">
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <ul className="pagination">
            {this.renderPreviousPage()}
            {this.renderPageNumbers()}
            {this.renderNextPage()}
          </ul>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div className="form-group row">
            <label htmlFor="pagina" className="col-md-10 col-sm-9 col-xs-8 m-t-5" >{I18nUtils.tr('TR_IR_A_PAGINA')}:</label>
            <div className="col-md-2 col-sm-3 col-xs-4">
              <div className="border-form">
                <select className="form-control show-tick" id="pagina" value={this.props.data.current} onChange={(e) => this.selectPage(parseInt(e.target.value, 10))}>
                  {[...Array(this.props.data.total_pages).keys()].map((i) => <option key={i} value={i + 1}>{i + 1}</option>)}
                </select>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }

}

Paginator.propTypes = {
  data: PropTypes.shape({
    current: PropTypes.number.isRequired,
    total_pages: PropTypes.number.isRequired,
  }),
  onPage: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Paginator.js